<template>
  <vs-popup
    classContent="popup-example"
    title="Attendee Info"
    :active.sync="show"
  >
    <div v-if="ticket != null">
      <h1>{{ ticket.ticket }}</h1>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-base">
          <vs-input
            class="inputx"
            style="width:100%;"
            placeholder=""
            v-model="ticket.firstName"
          />
        </div>
        <div class="vx-col w-full md:w-1/2 mb-base">
          <vs-input
            class="inputx"
            style="width:100%;"
            placeholder=""
            v-model="ticket.lastName"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-base">
          <vs-input
            class="inputx"
            style="width:100%;"
            placeholder=""
            v-model="ticket.email"
          />
        </div>
        <div class="vx-col w-full md:w-1/2 mb-base">
          <vs-input
            class="inputx"
            style="width:100%;"
            placeholder=""
            v-model="ticket.phone"
            onkeypress="return /^[-+0-9]/i.test(event.key)"
            onpaste="return false"
          />
        </div>
      </div>
      <div class="vx-row my-5" v-for="(item, i) in fields" :key="i">
        <div class="vx-col w-full">
          <div>{{ item.field_q }}</div>

          {{ item.field_a }}
          <template v-if="item.field_type == 'text'">
            <vs-input
              class="inputx"
              style="width:100%;"
              placeholder=""
              v-model="item.field_a"
            />
          </template>
          <template v-if="item.field_type == 'radio'">
            <ul class="leftx">
              <li class="modelx" v-for="(choice, c) in item.options" :key="c">
                <vs-radio
                  v-model="item.field_a"
                  vs-name="radios1"
                  :vs-value="choice"
                  >{{ choice }}</vs-radio
                >
              </li>
            </ul>
          </template>
          <template v-if="item.field_type == 'checkbox'">
            <div class="my-2" v-for="(choice, c) in item.options" :key="c">
              <vs-checkbox :value="choice" v-model="item.field_a">{{
                choice
              }}</vs-checkbox>
            </div>
          </template>
          <template v-if="item.field_type == 'select'">
            <vs-select
              class="selectExample"
              style="width:100%;"
              v-model="item.field_a"
            >
              <vs-select-item
                :key="c"
                :value="choice"
                :text="choice"
                v-for="(choice, c) in item.options"
              />
            </vs-select>
          </template>
          <template v-if="item.field_type == 'country'">
            <vs-select
              autocomplete
              class="selectExample"
              style="width:100%;"
              v-model="item.field_a"
            >
              <vs-select-item
                :key="index"
                :value="item"
                :text="item"
                v-for="(item, index) in countries"
              />
            </vs-select>
          </template>
        </div>
      </div>
      <!-- <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <label>Order Remark</label>
          <vs-textarea v-model="ticket.order.remark" />
        </div>
      </div> -->
      <vs-divider />
      <div class="text-right">
        <vs-button style="display:inline-block;" class="mr-2" @click="submit"
          >Save</vs-button
        >
      </div>
    </div>
  </vs-popup>
</template>
<script>
import { mapState } from "vuex";
import Service from "@/services";
import { countries } from "@/utils/Countries";

export default {
  components: {},
  props: {
    showDialog: false,
    attendee: null
  },
  data: () => ({
    ticket: null,
    fields: [],
    countries: []
  }),
  computed: {
    show: {
      get() {
        if (this.showDialog) {
          Service.Ticket.get(this.attendee.ticket).then(res => {
            this.ticket = res.data.ticket;

            [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(key => {
              if (this.ticket.event["field_status" + key]) {
                let options = [];

                if (this.ticket.event["field_opt" + key] != null) {
                  options = this.ticket.event["field_opt" + key].split(";");
                }

                this.fields.push({
                  key: key,
                  field_q: this.ticket.event["field_q" + key],
                  field_desc: this.ticket.event["field_desc" + key],
                  field_type: this.ticket.event["field_type" + key],
                  field_opt: this.ticket.event["field_opt" + key],
                  field_a: this.ticket["field_a" + key],
                  options: options
                });
              }
            });
          });

          for (var key in countries) {
            if (countries.hasOwnProperty(key)) {
              this.countries.push(countries[key]);
            }
          }
        } else {
          this.fields = [];
          this.ticket = null;
        }
        return this.showDialog;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      }
    }
  },
  methods: {
    submit() {
      let data = {
        ticket: this.ticket.ticket,
        firstName: this.ticket.firstName,
        lastName: this.ticket.lastName,
        email: this.ticket.email,
        mobile: this.ticket.mobile,
        remark: this.ticket.order.remark,
        fields: this.fields
      };
      this.$vs.loading();
      Service.Ticket.update(data).then(res => {
        this.$vs.loading.close();
        this.$emit("submit");
      });
    }
  }
};
</script>
